import { BannersProducts } from "../modules"

export const BannersProductsPage = () => {
  return (
    <BannersProducts />
  )
}
